import classnames from 'classnames'
import { useMemo } from 'react'
import { PRISMIC_TYPES } from '~/lib/prismic-types'

import { ProductCardProps } from '~/components/Slices/ProductCard'
import ResultsGrid, {
  ResultsGridProps,
} from '~/components/Slices/Search/ResultsGrid'

import { TSearchData } from '~/providers/ShopifySearchProvider'

import { getListName } from '~/hooks/tracking/utils'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ResultGridsContainerProps
  extends Omit<ResultsGridProps, 'cards'> {
  cards?: TSearchData[]
  hasResults?: boolean
  position?: number
}

export default function ResultGridsContainer({
  hasResults,
  cards,
  position,
  ...rest
}: ResultGridsContainerProps) {
  const processed = cards?.map((card, index) => ({
    ...card,
    trackingGTMData: {
      list: getListName(PRISMIC_TYPES.SEARCH),
      position: `${position + index + 1}`,
    },
  })) as ProductCardProps[]

  /* in order to trigger the product impression event */
  const stringifiedKey = JSON.stringify(processed)
  const memoizedKey = useMemo(() => stringifiedKey, [stringifiedKey])

  return hasResults ? (
    <div className={cx(css.ResultGridContainer)} key={memoizedKey}>
      <ResultsGrid className={css.resultGrid} cards={processed} {...rest} />
    </div>
  ) : null
}
